<template>
  <div id="app">
    <top-nav></top-nav>
    <masthead></masthead>
    <router-view></router-view>
    <site-footer></site-footer>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TopNav from '@/components/common/TopNav'
import Masthead from '@/components/common/Masthead'
import SiteFooter from '@/components/common/SiteFooter'
import Player from '@/components/common/Player'

export default {
  name: 'app',
  components: {
    TopNav,
    Masthead,
    SiteFooter,
    Player
  },
  mounted () {
    this.getSiteInfo()
  },
  methods: {
    getSiteInfo () {
      let vm = this
      // GET /site => get_site_info() [theme-folder]/api/functions.php
      vm.$axios.get('/site')
      .then((response) => {
        vm.setSiteInfo(response.data)
      })
      .catch((err) => {
        console.log(err.response)
      })
    },
    ...mapActions([
      'setSiteInfo'
    ])
  }
}
</script>

<style lang="sass">
  @import './assets/styles/variables'
  @import '~bulma'
  @import './assets/styles/typography'
  @import './assets/styles/mixins'
  @import './assets/styles/global'
</style>



// WEBPACK FOOTER //
// App.vue?3787137a